import RelatedPagesComponent from "../../../../components/help/RelatedPagesComponent.tsx";
import {Link} from "react-router-dom";
import {imageMap} from "../../../../images/imageMap.ts";
import Routing from "../../../../Routing.ts";


export default function GamingArticle() {
    return (
        <>
            <article className="help-article-content">
                <div className="article">
                    <div className="text-box text-box--gray">
                        <p>
                            Når du gamer online, er en stabil og hurtig internetforbindelse afgørende.
                            Forsinkelser og lag kan være forskellen mellem sejr og nederlag, og derfor
                            er det vigtigt at vælge det bedste internet til gaming.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Hvad er det bedste internet til gaming?</h2>
                        <p>
                            Det bedste internet til gaming er klart <Link to={Routing.Broadband.Fiber}>fibernet</Link>, som kan måle 1000 Mbit/s i download og upload.
                            Fibernet er en teknologi, som bruger lyslederkabler til at levere internet, og som bevæger sig i lysets hastighed. Af den grund er det det hurtigste 
                            internet du kan få, og det bedste internet til gaming. Slå din adresse op her for at se, hvilken internetforbindelse, som vi kan levere til 
                            din adresse: <Link to={Routing.Order} rel={'nofollow'}>Tjek din adresse</Link>{' '}
                        </p>
                    </div>
                    <img
                        className="paragraph-image mb0"
                        src={imageMap.help.subscription.gaming_1}
                        alt="Med det rette internet til gaming, får du den komplette gaming-oplevelse."
                    />
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Hvor mange Mbit skal jeg bruge til gaming?</h2>
                        <p>
                            Hvis du vil have det optimale ud af din gaming-oplevelse, er <Link to={'/hjaelp/internet-og-wifi/hvordan-traekker-jeg-1000-mbit'}>1000 Mbit</Link> en god idé, da det gør at du kan hente dine spil og deres opdateringer meget hurtigere.
                            Hvis dit spil f.eks. Har en stor opdatering der fylder 20 GB, så ville det tage omkring 30 minutter at downloade den med en 100 Mbit forbindelse, og omkring
                            kun 3 minutter med en 1000 Mbit forbindelse. En lidt lavere hastighed kan også gøre det, men 1000 Mbit er ideelt til gaming, da du er meget hurtigere inde i
                            kampen igen og klar til at spille med dine venner.
                        </p>
                        <p>
                            Med fibernet kan du få en symmetrisk hastighed på download/upload (1000/1000), som optimerer din gaming-oplevelse, hvad enten du spiller CS2, Fortnite,
                            Dota 2 eller noget helt fjerde.
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>Hvad betyder ping og latenstid for gaming?</h2>
                        <p>
                            Jo lavere ping du har, des hurtigere reaktionstid har dit spil, og så vil det føles meget mere responsivt. 
                            Latenstid betegner den tid, det tager for data at rejse frem og tilbage til en spilserver, og dette er afgørende, når du gamer. Er latenstiden høj, er ping høj og omvendt. 
                            Ved gaming er det bedst at have en latenstid, der er under 30 ms. 
                        </p>
                    </div>
                </div>

                <div className="article">
                    <div className="paragraph">
                        <h2>5G-internet til gaming</h2>
                        <p>
                            Hvis du ikke har mulighed for fibernet på din adresse, så kan du alternativt bruge <Link to={Routing.Broadband.TDC5G}>5G-internet</Link> til gaming.
                            Fibernet er både hurtigere og mere stabilt end 5G-internet, især med henblik på gaming, men derfor kan du stadig godt game med dit 5G-internet. En 5G-internet 
                            forbindelse er nemlig påvirket af vind og vejr, og det er fibernet ikke, da fiberkablerne ligger i jorden.
                        </p>
                        <p>
                            Men hvis du køber 5G-internet hos os, får du en wifi 7-lånerouter med i dit abonnement, som er den nyeste wifi-teknologi på markedet,
                            de giver bedre stabilitet end tidligere teknologier. Hvis du vil blive lidt klogere på forskellene mellem de forskellige internetforbindelser,
                            kan du læse mere i artiklen: <Link to={'/hjaelp/internet-og-wifi/hvilket-internet-skal-jeg-vaelge'}>Hvilket internet skal jeg vælge?</Link>
                        </p>
                    </div>
                    <img
                        className="paragraph-image mb0"
                        src={imageMap.help.subscription.gaming_2}
                        alt="Person som gamer med godt internet"
                    />
                </div>
                <div className="article">
                    <div className="paragraph">
                        <h2>Sådan får du mest ud af din gaming</h2>
                        <ul className="big-steps">
                            <li>
                                <h3>Vælg en hurtig og stabil internetforbindelse</h3>
                                <ul>
                                    <li>
                                        <p>
                                            1000/1000 Mbit fibernet er det bedste internet til gaming, så du får ultra lav ping og latency og en mega stabil forbindelse.
                                        </p>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <h3>Brug en kablet forbindelse (Ethernet)</h3>
                                <ul>
                                    <li>
                                        <p>
                                            Wifi er ikke lige så hurtigt og stabilt som internet via en direkte kabeltilslutning til din computer eller konsol. Derfor skal du bruge en kablet forbindelse for at opnå den bedste ydeevne.
                                        </p>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <h3>Hvis du bruger wifi til gaming</h3>
                                <ul>
                                    <li>
                                        <p>
                                            Hvis du bruger wifi fra din router, så brug gerne 5 GHz-frekvensbåndet. Med et frekvensbånd på 5 GHz får du en kortere bølgelængde og 
                                            du sikrer dig en hurtigere forbindelse, til sammenligning med 2,4 GHz. Du kan læse mere om frekvensbånd <Link to={'/hjaelp/internet-og-wifi/forskel-paa-signal-frekvenser'}>her.</Link>
                                        </p>
                                        <p>
                                            Brug kun 2,4 GHz, hvis din computer eller konsol er længere væk fra routeren - 2,4 GHz er langsommere end 5 GHz, men har en længere rækkevidde.
                                            Så hvis du er uden for den optimale rækkevidde på 5 GHz, er 2,4 GHz bedre.
                                        </p>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <h3>Optimér placeringen af din router</h3>
                                <ul>
                                    <li>
                                        <p>
                                            Hvis du bruger wifi til gaming, så placér din router centralt i hjemmet eller alternativt flyt den over ved siden af dig, når du spiller.
                                        </p>
                                        <p>
                                            Hvis du har 5G-internet, er det oftest bedst at sætte routeren i den vindueskarm, der er tættest på den nærmeste 5G-mast.
                                            Det er meget svært at vide hvilken vindueskarm det præcist er, så vi anbefaler at man prøver sig frem ved at placere den forskellige steder.
                                        </p>
                                        <p>
                                            Læs mere om den ideelle <Link to={'/hjaelp/internet-og-wifi/placering-af-router'}>placering af din router.</Link>
                                        </p>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <h3>Optimér din software og indstillinger</h3>
                                <ul>
                                    <li>
                                        <p>
                                            Sørg for at holde dit grafik- og netværkskort, og andre drivere på din computer opdateret, da det ellers kan skabe problemer hvis de er forældede.
                                        </p>
                                        <p>
                                            Hvis din computer ikke er særlig kraftig, kan du optimere dine grafikindstillinger i spil, ved at nedjustere opløsning (resolution), teksturkvalitet
                                            (texture quality) og andre grafiske indstillinger, som at slå ray tracing fra, hvis det er slået til. Hvis du har et NVIDIA grafikkort, kan du prøve at 
                                            slå NVIDIA DLSS til og teste dets forskellige indstillinger, som har mulighed for at booste din FPS og kvalitet, uden at gå på kompromis med ydeevne.
                                        </p>
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <h3>Investér eventuelt i godt udstyr</h3>
                                <ul>
                                    <li>
                                        <p>
                                            Få en god skærm med høj opdateringshastighed. Du kan også få mekaniske tastaturer, som giver hurtigere reaktionstid og en gaming-mus med høj DPI, 
                                            som kan forbedre din præcision. Der er mange andre fysiske faktorer, som kan forbedre din gaming-oplevelse som gaming-stol, skrivebord, headset, mikrofon, 
                                            musemåtte osv.
                                        </p>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="article">
                    <div className="paragraph">
                        <h2>Hiper og e-sport</h2>
                        <p>
                            Hiper har tidligere arbejdet sammen med e-sports organisationen, Heroic om lynhurtigt internet,
                            det kan du læse mere om i en tidligere pressemeddelelse <Link to={'/presse/hiper-og-heroic-gaar-sammen-2018-01-23'}>her.</Link>
                        </p>
                    </div>
                </div>
                <div className="article">
                    <div className="paragraph">
                        <h2>Skal du have lynhurtigt internet til din gaming?</h2>
                        <Link to={Routing.Order} rel={'nofollow'}>Bestil din forbindelse her.</Link>
                    </div>
                </div>
            </article>

            <RelatedPagesComponent
                articles={[
                    {
                        "link": Routing.Broadband.Fiber,
                        "name": "Bestil fibernet"
                    },
                    {
                        "link": Routing.Broadband.TDC5G,
                        "name": "Bestil 5G-internet"
                    },
                    {
                        "link": Routing.Broadband.Coax,
                        "name": "Bestil coax internet"
                    },
                    {
                        "link": "/hjaelp/internet-og-wifi/hvilket-internet-skal-jeg-vaelge",
                        "name": "Hvilket Internet skal jeg vælge?"
                    }
                ]}
            />
        </>
    )
}
